export default __webpack_public_path__ + "static/media/donotcover.3b04c136.png";